import $axios from '@/store/axios-instance.js';

import clientServiceHistory from "@/store/client/clientServiceHistory";
import clientSuspendHistory from "@/store/client/clientSuspendHistory";
import clientWebCash from "@/store/client/clientWebCash";
import clientStationList from "@/store/client/clientStationList";
import clientPrinterList from "@/store/client/clientPrinterList";
import clientContact from "@/store/client/clientContact";
import clientDocumentList from "@/store/client/clientDocumentList";
import clientRemotesList from "@/store/client/clientRemotes";
import clientServices from "@/store/client/clientServices";
import clientChild from "@/store/client/clientChild";

export default {
    state: {
        clientDictionaryList: null,
        clientList: null,
        currentClient: null,
    },
    mutations: {
        retrieveClientDictionaryList(state, payload) {
            state.clientDictionaryList = payload
        },
        retrieveClientsList(state, payload) {
            state.clientList = payload
        },
        retrieveClient(state, payload) {
            state.currentClient = payload
        },
        deleteClient(state, payload) {
            if(state.clientList.clients){
                let entityIndex = state.clientList.clients.findIndex(function (item) {
                    return item.id === payload
                })
                if (entityIndex > -1) {
                    state.clientList.clients.splice(entityIndex, 1)
                }
            }
        },
    },
    actions: {
        retrieveClientDictionaryList(context) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('clients/dictList')
                    .then(response => {
                        context.commit('retrieveClientDictionaryList', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveClientList(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .get('clients', {
                        params: payload
                    })
                    .then(response => {
                        context.commit('retrieveClientsList', response.data)

                        resolve(response.data)
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        retrieveClient(context, payload) {
            return new Promise((resolve, reject) => {
                if (!payload) {
                    context.commit('retrieveClient', null)
                    resolve()
                } else {
                    $axios
                        .get(`clients/${payload}`)
                        .then(response => {
                            context.commit('retrieveClient', response.data)

                            context.dispatch('retrieveClientWebCash', null)
                            context.dispatch('retrieveClientSuspendHistory', null)
                            context.dispatch('retrieveClientServiceHistory', null)
                            context.dispatch('retrieveClientStations', null)
                            context.dispatch('retrieveClientPrinters', null)

                            resolve(response.data)
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        createClient(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .post(`clients`, {
                        id: payload.id,
                        companyId: payload.company.id,
                        name: payload.name,
                        address: payload.address,
                        launchDate: payload.launchDate,
                        closeDate: payload.closeDate,
                        hostingDate: payload.hostingDate,
                        licenseTypeId: payload.licenseType.id,
                        licenseDescription: payload.licenseDescription,
                        serverAddress: payload.serverAddress,
                        softwareVersionTypeId: payload.softwareVersionType.id,
                        serverPassword: payload.serverPassword,
                        networkDescription: payload.networkDescription,
                        parentClientId: payload.parentClient?.id
                    })
                    .then(() => {
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        storeClient(context, payload) {
            return new Promise((resolve, reject) => {
                $axios
                    .put(`clients`, {
                        id: payload.id,
                        companyId: payload.company.id,
                        name: payload.name,
                        address: payload.address,
                        launchDate: payload.launchDate,
                        closeDate: payload.closeDate,
                        hostingDate: payload.hostingDate,
                        licenseTypeId: payload.licenseType.id,
                        licenseDescription: payload.licenseDescription,
                        serverAddress: payload.serverAddress,
                        softwareVersionTypeId: payload.softwareVersionType.id,
                        serverPassword: payload.serverPassword,
                        networkDescription: payload.networkDescription,
                        parentClientId: payload.parentClient?.id
                    })
                    .then(() => {
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
        deleteClient(context, payload){
            return new Promise((resolve, reject) => {
                $axios
                    .delete(`clients/${payload}`)
                    .then(() => {
                        context.commit('deleteClient', payload)
                        resolve()
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error)
                    })
            })
        },
    },
    getters: {
        clientList(state) {
            return state.clientList ? state.clientList.clients : []
        },
        clientListTotal(state) {
            return state.clientList ? state.clientList.clientCount : 0
        },
        clientDictionaryList(state) {
            return state.clientDictionaryList
        },
        currentClient(state) {
            return state.currentClient
        },
    },
    modules: {
        clientServiceHistory,
        clientSuspendHistory,
        clientWebCash,
        clientStationList,
        clientPrinterList,
        clientContact,
        clientDocumentList,
        clientRemotesList,
        clientServices,
        clientChild
    }
}